<app-base-header-secondary></app-base-header-secondary>
<header *ngIf="displaySecondaryHeader" id="secondaryHeader" aria-labelledby="Secondary header" class="cx-subheader sticky-top bg-white" style="z-index: 1030;">
  <div class="d-none d-lg-flex p-3 align-items-center">
    Secondary header content will display here.
  </div>
</header>
